import React from 'react';
import { KawaiiButton } from '@components/button';
import { MessageCircle } from 'lucide-react';

interface SidebarChatItemProps {
  id: number;
  selected: boolean;
  isCollapsed: boolean;
  onClick: (id: number) => void;
  onContextMenu: (e: React.MouseEvent, chatId: number) => void;
}

const SidebarChatItem = React.memo<SidebarChatItemProps>(
  ({ selected, isCollapsed, id, onClick, onContextMenu }) => {
    return (
      <KawaiiButton
        type="button"
        variant={selected ? 'primary' : 'secondary'}
        onClick={() => onClick(id)}
        onContextMenu={(e) => onContextMenu(e, id)}
        className={`group border-0 flex justify-start bg-transparent 
           hover:bg-pink-200/80 active:bg-pink-300/80
          aspect-square p-0 max-h-[46px] rounded-md w-[calc(100%-.5rem)]`}
      >
        <div className="p-3 text-pink-300 dark:text-gray-300 group-active:text-pink-500 group-hover:text-pink-400">
          <MessageCircle strokeWidth={1.5} size={24} />
        </div>
        {!isCollapsed && (
          <span className="text-sm text-pink-600 dark:text-gray-300">
            {/* Maybe chat title here? */} {id}
          </span>
        )}
      </KawaiiButton>
    );
  },
);

SidebarChatItem.displayName = 'SidebarChatItem';

export default SidebarChatItem;
